// The Templates button insert and the carrier choice line (2026-10-26,
// docs/contact-view.md "Templates button: the carrier choice line"): a
// template an agent inserts by hand that carries "Carrier: UPS / USPS / ATS"
// gets the order's one carrier, by the same rule and the same customer-facing
// mapping the server uses for drafts (resolveCarrierChoiceLines() in
// @cxhub/shared, Amazon as AMZ). Mixed carriers, an unknown carrier or no
// tracking: the line is left as it is and the reply box highlights it. Pure.
import { resolveCarrierChoiceLines } from '@cxhub/shared'

// The order's tracking from the order header's trackingSummary
// ([{ trackingNumber, carrier, url, source, sku }], source 'parent' for the
// order's own, a replacement's order id otherwise; parent first, then each
// replacement): { orderTracking, currentTracking } as [{ number, carrier }].
// The current shipment, as the server's buildShipments() decides it: per SKU,
// the newest shipment (the last one listed); an entry with no SKU counts as
// current.
export function templateCarrierTracking(trackingSummary) {
  const list = (trackingSummary ?? []).filter((t) => t?.trackingNumber)
  const orderTracking = []
  for (const t of list) {
    if (!orderTracking.some((o) => o.number === t.trackingNumber)) orderTracking.push({ number: String(t.trackingNumber), carrier: t.carrier ?? null })
  }
  const newestSourceBySku = new Map()
  for (const t of list) if (t.sku) newestSourceBySku.set(t.sku, t.source ?? 'parent')
  const currentTracking = []
  for (const t of list) {
    if (t.sku && newestSourceBySku.get(t.sku) !== (t.source ?? 'parent')) continue
    if (!currentTracking.some((o) => o.number === t.trackingNumber)) currentTracking.push({ number: String(t.trackingNumber), carrier: t.carrier ?? null })
  }
  return { orderTracking, currentTracking }
}

// The template's content (HTML or plain text) with its carrier choice line
// resolved from the order's tracking, or unchanged.
export function resolveTemplateCarrierChoice(content, trackingSummary) {
  const { orderTracking, currentTracking } = templateCarrierTracking(trackingSummary)
  const result = resolveCarrierChoiceLines(content, { orderTracking, currentTracking: currentTracking.length ? currentTracking : orderTracking })
  return result.carrier ? result.content : content
}
